export const DataHooks = {
  text: 'adaptive-heading-text',
  textInShort: 'adaptive-heading-text-in-short',
};
